var windowWidth=$(window).width();
(function(){
    resize_windows();
    $(window).resize(function(){
      $('#header .toggle_bar').removeClass('active')
        if(windowWidth!=$(window).width()){
          resize_windows()
          windowWidth=$(window).width()
        }
    });

function resize_windows(){
  if($(window).width() <= 1200){
    $('#header .menu_list').hide();
    $('#header .menu_list .menu_list_bottom>li').off('mouseenter');
    $('#header .menu_list .menu_list_bottom>li').off('mouseleave');
    $('#header .menu_list .menu_list_bottom>li>span').click(function(event){
      var event = event || window.event;
      event.stopPropagation() ? event.stopPropagation() : event.cancelBubble = true
      if($(this).parent('li').hasClass('active')){
        $(this).parent('li').removeClass('active')
        $(this).parent('li').find('.drop_list_box').hide()
      }else{
        $(this).parent('li').addClass('active').siblings().removeClass('active');
        $(this).parent('li').find('.drop_list_box').show()
      }
      $(this).parent('li').siblings().find('.drop_list_box').hide();
    });
  }else{
    $('#header .menu_list').css({'display':"block"});
    $('#header .menu_list .menu_list_bottom li').on('mouseenter',debounce(function(){
      $(this).addClass('active').siblings().removeClass('active');
      $(this).find('.drop_list_box').show();
      $(this).siblings().find('.drop_list_box').hide();
    },100))
    $('#header .menu_list .menu_list_bottom li').on('mouseleave',function(){
      $(this).removeClass('active');
      $(this).find('.drop_list_box').hide();
      $(this).siblings().find('.drop_list_box').hide();
    });
  }
}
    $('#header .toggle_bar').click(function(event){
      var event = window.event || event;
      event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
        $('.menu_list').slideToggle();
        $(this).toggleClass('active')
    })
    // footer
    $('#footer .language_box').click(function(event){
      var event = window.event || event;
      event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
        $('#footer .language_list').slideToggle()
        $('#footer .language_box').toggleClass('active');
        if(event.target.nodeName.toLowerCase() == 'li'){
          var now_language = event.target.getAttribute('data-value');
          doGTranslate(now_language);
        }
    });
    $(document).click(function(){
       if($(window).width()<1200){
        $('.menu_list').hide();
        $('#header .toggle_bar').removeClass('active')
        $('#footer .language_box').removeClass('active');
       }
       $('.language_list').hide();
       $('#footer .language_box').removeClass('active');
    })
    if($(window).width() <= 1200){
      $('#footer .footer_list .footer_item').click(function(event){
        var event = window.event || event;
        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
          $(this).find('.footer_item>ul').slideToggle();
          $(this).toggleClass('active');
      })
    }
    // 防抖
    function debounce(fn,speed){
      var timer = null;
      return function(){
        var that  = this;
        var arg = arguments;
        setTimeout(timer);
        if(!timer){
            setTimeout(function(){fn.apply(that,arg)},speed)
        }
      }
    }
})(windowWidth);
function doGTranslate(lang_pair) {if(lang_pair.value)lang_pair=lang_pair.value;if(lang_pair=='')return;var lang=lang_pair.split('|')[1];var plang=location.pathname.split('/')[1];if(plang.length !=2 && plang.toLowerCase() != 'zh-cn' && plang.toLowerCase() != 'zh-tw')plang='en';if(lang == 'en')location.href=location.protocol+'//'+location.host+location.pathname.replace('/'+plang+'/', '/')+location.search;else location.href=location.protocol+'//'+location.host+'/'+lang+location.pathname.replace('/'+plang+'/', '/')+location.search;}